import React, { useState, } from 'react';
import fileDownload from 'js-file-download';
import { unparse as unparseCsv, } from 'papaparse';
import { isFunction } from 'lodash';
import classnames from 'classnames';
import { Button, } from 'reactstrap';

import { encode } from '../util';
import { mapKeysToJa, } from '../shared/texts';

export default function ExportButton ({ label = 'エクスポート', fileName, rows, encoding = 'Shift_JIS', ...extraProps }) {
  const [isExporting, setIsExporting] = useState(false);

  const onClickExport = async () => {
    setIsExporting(true);
    const _rows = (isFunction(rows) ? (await rows()) : rows).map(_ => mapKeysToJa(_));
    const fileContent = encode(unparseCsv(_rows), encoding);
    fileDownload(fileContent, fileName);
    setIsExporting(false);
  };

  return (
    <Button color="secondary" onClick={onClickExport} disabled={isExporting} {...extraProps}>
      <span className={classnames('fas', { 'me-1': !!label, 'fa-spin fa-spinner': isExporting, 'fa-download': !isExporting })} />
      {label}
    </Button>
  );
};
